export default __webpack_public_path__ + "static/media/Relikof-Kidz-eng.eeec069a.jpg";